export function generateHomeMetaDescription(): string {
  return 'Explore the complete Pokémon Trading Card Game database. Search cards, view prices, track collections, and discover the most valuable Pokémon cards.';
}

export function generateHomeOpenGraph() {
  return {
    title: 'Pokémon Card Index - Comprehensive Pokémon TCG Database',
    description: generateHomeMetaDescription(),
    image: 'https://pokecardindex.com/og-image.jpg',
    type: 'website'
  };
}

export function generateHomeSchema() {
  return JSON.stringify({
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "Pokémon Card Index",
    "description": generateHomeMetaDescription(),
    "url": "https://pokecardindex.com",
    "potentialAction": {
      "@type": "SearchAction",
      "target": {
        "@type": "EntryPoint",
        "urlTemplate": "https://pokecardindex.com/search?q={search_term_string}"
      },
      "query-input": "required name=search_term_string"
    }
  });
} 